<template>
  <div class="About">
    <h1>This is an about page</h1>
    <p>{{userInfo}}</p>
    <button @click="backlc">返回</button>
    <button @click="backnative">原生返回</button>
  </div>
</template>
<script>
export default {
  name: "About",
  mounted: function () {
    let self = this;
    //在这里获取下用户信息
    window.connectWebViewJavascriptBridge(function (bridge) {
      var data = {
        msg: navigator.userAgent,
      };
      bridge.callHandler("getUserInfo", data, function (response) {
        console.log(response);
        self.userInfo = response;
      });
    });
  },
  data: function () {
    return {
      userInfo: "xx",
    };
  },
  methods: {
    backlc() {
      if (document.referrer == "") {
        this.closeMe();
      } else {
        alert("referrer不为空:" + document.referrer);
        window.history.go(-1);
        return;
      }
    },
    backnative() {
      console.log("原生返回");
      var data = {};
      console.log(JSON.stringify(data));
      window.connectWebViewJavascriptBridge(function (bridge) {
        bridge.callHandler("goback", data, function (response) {
          console.log(response);
        });
      });
    },
    closeMe() {
      console.log("关闭");
      var data = {};
      console.log(JSON.stringify(data));
      window.connectWebViewJavascriptBridge(function (bridge) {
        bridge.callHandler("closePage", data, function (response) {
          console.log(response);
        });
      });
    },
  },
};
</script>
